import { Link } from "@mui/material";

import { Breadcrumbs } from "@mui/material";
import { useGo, useResource } from "@refinedev/core";

export default function PlaygroundBreadcrumbs({
  brandName,
  brandId,
  batchName,
  batchId,
}: {
  brandName?: string;
  brandId?: string;
  batchName?: string;
  batchId?: string;
}) {
  const go = useGo();
  const { resource } = useResource();
  const isHome = resource?.name === "home";
  const isBrand = resource?.name === "brand";
  const isBatch = resource?.name === "batch";
  const isJob = resource?.name === "job";

  return (
    <Breadcrumbs sx={{ width: "100%", mb: 2 }} separator=">">
      <Link
        component="button"
        onClick={() => {
          go({
            to: {
              resource: "home",
              action: "list",
            },
          });
        }}
        color={isHome ? "primary" : "inherit"}
        underline="hover"
      >
        Home
      </Link>
      <Link
        component="button"
        onClick={() => {
          go({
            to: {
              resource: "brand",
              action: "list",
            },
          });
        }}
        color={isBrand ? "primary" : "inherit"}
        underline="hover"
      >
        Brands
      </Link>
      {(isBatch || isJob) && (
        <Link
          component="button"
          onClick={() => {
            go({
              to: {
                resource: "batch",
                action: "list",
                meta: {
                  brandName,
                  brandId,
                },
              },
            });
          }}
          color={isBatch ? "primary" : "inherit"}
          underline={"hover"}
        >
          {brandName}
        </Link>
      )}
      {isJob && (
        <Link
          component="button"
          onClick={() => {
            go({
              to: {
                resource: "job",
                action: "list",
                meta: {
                  brandName,
                  brandId,
                  batchName,
                  batchId,
                },
              },
            });
          }}
          color={isJob ? "primary" : "inherit"}
          underline="hover"
        >
          {batchName}
        </Link>
      )}
    </Breadcrumbs>
  );
}
